import { NotificationVariation } from '@salecycle/ui-component-library';

export enum ActionTypes {
  NOTIFICATION_CLOSED = 'NotificationClosed',
  CUSTOM_NOTIFICATION = 'CustomNotification',
}
// Actions
export interface NotificationClosed {
  type: ActionTypes.NOTIFICATION_CLOSED;
}

export interface CustomNotification {
  type: ActionTypes.CUSTOM_NOTIFICATION;
  variation: NotificationVariation;
  detail: string;
}

export type Action = NotificationClosed | CustomNotification;

// Action Creators
export const Actions = {
  closeNotification: (): NotificationClosed => ({
    type: ActionTypes.NOTIFICATION_CLOSED,
  }),
  customNotification: (variation: NotificationVariation, detail: string): CustomNotification => ({
    type: ActionTypes.CUSTOM_NOTIFICATION,
    variation,
    detail,
  }),
};
